<template>
  <v-expansion-panel>
    <v-expansion-panel-header v-slot="{ open }">
      <v-row no-gutters>
        <v-col cols="4" class="blue--text text--darken-1"> Bon d'Installation </v-col>
        <v-col cols="8" class="text--secondary">
          <v-fade-transition leave-absolute>
            <span v-if="open" key="0"> Editer le bon puis sauvegarder </span>
            <span v-else key="1">
              <div v-if="bonInstallation.account">
                {{ bonInstallation.account.name }}
              </div>
              <div v-if="bonInstallation.laverie">
                / {{ bonInstallation.laverie.name }}
              </div>
            </span>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonInstallation.account"
            :items="accounts"
            :item-text="'name'"
            return-object
            label="Siège"
            @update:model-value="onAccountChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonInstallation.laverie"
            :items="laveries"
            :item-text="'name'"
            return-object
            label="Laverie"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.laverie && bonInstallation.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            v-model="bonInstallation.laverie.address.numero"
            name="numero"
            hint="Le numéro dans la rue"
            class="input-group--focused"
            label="Numero"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="rue"
            hint="Le nom de la rue"
            v-model="bonInstallation.laverie.address.rue"
            class="input-group--focused"
            label="Rue"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez l'adresse si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.laverie && bonInstallation.laverie.address" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="1">
          <v-text-field
            name="codepostale"
            hint="Le code postale de la ville"
            v-model="bonInstallation.laverie.address.codepostale"
            class="input-group--focused"
            label="Code Postale"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5">
          <v-text-field
            name="ville"
            hint="Le nom de la ville"
            v-model="bonInstallation.laverie.address.ville"
            class="input-group--focused"
            label="Ville"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonInstallation.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="acces"
            v-model="bonInstallation.laverie.codeAcces"
            class="input-group--focused"
            label="Accès"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Détaillez l'accessibilité
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.laverie" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-menu
            :close-on-content-click="true"
            v-model="dateMenu"
            transition="v-scale-transition"
            offset-y
            :nudge-left="40"
            max-width="290px"
          >
            <template v-slot:activator="{ props }">
              <v-text-field
                v-bind="props"
                label="Date d'installation"
                v-model="bonInstallation.installDate"
                prepend-icon="mdi-calendar"
                readonly
                @blur="onBlur"
              ></v-text-field>
            </template>
            <v-date-picker v-model="bonInstallation.installDate" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la date d'installation
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="gestionnaire"
            hint="Nom et prénom du gestionnaire"
            v-model="bonInstallation.laverie.gestionnaire"
            class="input-group--focused"
            label="Gestionnaire"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Changez le gestionnaire si nécessaire
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="telephone"
            v-model="bonInstallation.laverie.telephoneAutre"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="mobile"
            v-model="bonInstallation.laverie.telephonePrincipal"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondPrenom"
            hint="Nom et prénom du contact secondaire"
            v-model="bonInstallation.contactSecond.name"
            class="input-group--focused"
            label="Autre contact"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez un contact secondaire
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field
            name="contactSecondTel"
            hint="Téléphone du contact secondaire"
            v-model="bonInstallation.contactSecond.telephone"
            class="input-group--focused"
            label="Téléphone"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            name="contactSecondMobile"
            hint="Mobile du contact secondaire"
            v-model="bonInstallation.contactSecond.mobile"
            class="input-group--focused"
            label="Mobile"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-text-field
            name="contactSecondFonction"
            hint="Fonction technique du contact secondaire"
            v-model="bonInstallation.contactSecond.fonction"
            class="input-group--focused"
            label="Fonction"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3"> </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installDate" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-select
            v-model="bonInstallation.installedBy"
            :items="users"
            :item-text="(item) => `${item.name} ${item.lastname}`"
            return-object
            label="Installé par"
            @update:model-value="onChange"
          ></v-select>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le technicien
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.installedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-text-field
            name="cleCaisse"
            v-model="bonInstallation.cleCaisse"
            class="input-group--focused"
            label="Clé caisse"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="cleTrappe"
            v-model="bonInstallation.cleTrappe"
            class="input-group--focused"
            label="Clé trappe"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            name="autreCle"
            v-model="bonInstallation.autreCle"
            class="input-group--focused"
            label="Autre clé"
            @blur="onBlur"
          >
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez les clés remises
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn
          :filePath="bonInstallationTemplatePath"
          :fileName="bonInstallationFileName"
          :dataSet="bonInstallationGen"
          >Save</generate-doc-btn
        >
      </v-card-actions>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { User } from "@/types";
import { BonInstallation, BonInstallationGen } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import { flattenBonInstallation } from "@/types";

interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

// Reactive state
const dateMenu = ref(false);
const bonInstallation = ref<BonInstallation>({
  contactSecond: {} as User,
} as BonInstallation);
const bonInstallationGen = ref<BonInstallationGen>(new BonInstallationGen());
const laveries = ref<Laverie[]>([]);

// Computed properties
const bonInstallationTemplatePath = computed(() => {
  return "templates/BonInstallationTemplate.docx";
});

const bonInstallationFileName = computed(() => {
  if (bonInstallation.value.laverie) {
    return "BonDInstallation_".concat(bonInstallation.value.laverie.name);
  }
  return "BonDInstallation";
});

// Methods
const onAccountChange = async (selectedAccount: Account) => {
  bonInstallation.value.account = selectedAccount;
  // Reset selected laverie
  bonInstallation.value.laverie = null;
  // Clear previous data
  laveries.value = [];
  await fetchLaveries(selectedAccount.id);
  // Regenerate document data
  bonInstallationGen.value = flattenBonInstallation(bonInstallation.value);
};

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onChange = () => {
  onBlur();
};

const onBlur = () => {
  bonInstallationGen.value = flattenBonInstallation(bonInstallation.value);
};

const onCancel = () => {
  // TODO clear form
  bonInstallation.value = {
    contactSecond: {} as User,
  } as BonInstallation;
  bonInstallationGen.value = new BonInstallationGen();
  laveries.value = [];
};

// Lifecycle
onMounted(() => {
  // Initialization if needed
});
</script>
